
import type { QuizQuestion, ResearchInsight } from '../types/quiz'

export const questions: QuizQuestion[] = [
  {
    id: 1,
    question: 'Which areas feel stiff or uncomfortable most often?',
    helper: 'Choose the area you notice most.',
    options: [
      'Knees',
      'Hips',
      'Hands and wrists',
      'Back or shoulders',
      'Several areas',
    ],
  },
  {
    id: 2,
    question: 'When do you notice stiffness the most?',
    helper: 'Pick the moment that feels most familiar.',
    options: [
      'Going up or down stairs',
      'During hobbies and activities I enjoy',
      'Getting up in the morning',
      'Later in the day, after moving around',
      'Throughout most of the day',
    ],
  },
  {
    id: 3,
    question: 'Which of these have you looked into before?',
    helper: 'This helps us skip what you already know about.',
    options: [
      'Over-the-counter pain relievers',
      'Glucosamine or chondroitin supplements',
      'Topical creams or gels',
      'Injections or in-clinic therapies',
      'Several of these',
    ],
  },
  {
    id: 4,
    question:
      'A Harvard-led team examined thousands of ancient skeletons and found far less joint decay than expected — suggesting "wear and tear" may not be the main driver. Had you heard about this?',
    helper: 'Either answer is fine — it just tells us where to start.',
    options: ['Yes, I had heard something about it', 'No, tell me more'],
  },
]

export const loadingSteps: string[] = [
  'Reviewing your answers',
  'Matching them with published research',
  'Preparing your research summary',
]

export const researchInsights: ResearchInsight[] = [
  {
    heading: 'The focus has shifted from cartilage to the fluid around it',
    body: 'Between the surfaces of a joint sits synovial fluid — a thick, gel-like substance some researchers informally call "joint jelly." It lubricates and cushions cartilage, and because cartilage has no blood supply of its own, it depends on this fluid for oxygen and nutrients.',
  },
  {
    heading: 'One molecule has been called "the guardian of the joints"',
    body: 'Hyaluronan is the molecule that helps synovial fluid hold water and stay thick. Published research indicates hyaluronan levels tend to decline with age — by roughly 2% per year after 40, according to work published in Arthritis Research & Therapy.',
  },
  {
    heading:
      'This may be why some popular supplements disappointed in trials',
    body: 'Glucosamine and chondroitin are marketed as cartilage building blocks. In a large two-year study of 572 participants, they were not found to outperform a placebo for pain or joint function — which researchers at Harvard-affiliated hospitals have publicly noted.',
  },
]
